import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faMapMarkerAlt, 
  faPhoneAlt, 
  faEnvelope
} from '@fortawesome/free-solid-svg-icons';
import { 
  faFacebookF, 
  faTwitter, 
  faInstagram, 
  faYoutube 
} from '@fortawesome/free-brands-svg-icons';
import Logo from './Logo';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <Logo size="normal" />
            <p className="text-gray-400 mb-4 mt-4">
              Lembaga Pelatihan dan Pengembangan Sumber Daya Manusia RTD-Cosmic Link.
            </p>
            <div className="flex space-x-4">
              <a href="https://facebook.com" className="text-gray-400 hover:text-white">
                <FontAwesomeIcon icon={faFacebookF} />
              </a>
              <a href="https://twitter.com" className="text-gray-400 hover:text-white">
                <FontAwesomeIcon icon={faTwitter} />
              </a>
              <a href="https://instagram.com" className="text-gray-400 hover:text-white">
                <FontAwesomeIcon icon={faInstagram} />
              </a>
              <a href="https://youtube.com" className="text-gray-400 hover:text-white">
                <FontAwesomeIcon icon={faYoutube} />
              </a>
            </div>
          </div>
          
          {/* Programs */}
          <div>
            <h4 className="text-lg font-bold mb-4">Program</h4>
            <ul className="space-y-2">
              <li><Link to="/program/rtd" className="text-gray-400 hover:text-white">Senam RTD</Link></li>
              <li><Link to="/program/cl" className="text-gray-400 hover:text-white">Cosmic Link</Link></li>
              <li><Link to="/program/entrep" className="text-gray-400 hover:text-white">Enterpreuner</Link></li>
              <li><Link to="/program/karisma" className="text-gray-400 hover:text-white">Karisma</Link></li>
              <li><Link to="/program/cv" className="text-gray-400 hover:text-white">Cosmic Voice</Link></li>
              <li><Link to="/program/ca" className="text-gray-400 hover:text-white">Cosmic Adventure</Link></li>
              <li><Link to="/program/seminar" className="text-gray-400 hover:text-white">Seminar & Workshop</Link></li>
            </ul>
          </div>
          
          {/* Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Tautan</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-400 hover:text-white">Beranda</Link></li>
              <li><Link to="/tentang" className="text-gray-400 hover:text-white">Tentang Kami</Link></li>
              <li><Link to="/program" className="text-gray-400 hover:text-white">Program & Kegiatan</Link></li>
              <li><Link to="/cabang" className="text-gray-400 hover:text-white">Cabang</Link></li>
              <li><Link to="/media" className="text-gray-400 hover:text-white">Media</Link></li>
              <li><Link to="/afiliasi" className="text-gray-400 hover:text-white">Afiliasi</Link></li>
              <li><Link to="/kontak" className="text-gray-400 hover:text-white">Hubungi Kami</Link></li>
            </ul>
          </div>
          
          {/* Contact */}
          <div>
            <h4 className="text-lg font-bold mb-4">Kontak</h4>
            <ul className="space-y-2">
              <li className="flex items-start">
                <FontAwesomeIcon icon={faMapMarkerAlt} className="mt-1 mr-3 text-gray-400" />
                <span className="text-gray-400">Jl. Terusan Cikutra Baru No. 29, Bandung, Indonesia</span>
              </li>
              <li className="flex items-center">
                <FontAwesomeIcon icon={faPhoneAlt} className="mr-3 text-gray-400" />
                <span className="text-gray-400">+62 21 1234 5678</span>
              </li>
              <li className="flex items-center">
                <FontAwesomeIcon icon={faEnvelope} className="mr-3 text-gray-400" />
                <span className="text-gray-400">info@rtdcl.com</span>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Copyright */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} LP2SDM RTD-CL. Hak Cipta Dilindungi.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
